import DashboardLayout from '../components/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Construction } from 'lucide-react';

/**
 * MediaDocsDashboard — "606 MEDIADOCS (التحكم)" from the Control & Info hub.
 * Intentionally a "Coming Soon" placeholder (same as the main dashboard button)
 * until the user defines its cards later.
 */
export default function MediaDocsDashboard() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const isAr = language === 'ar';

  const backTarget = '/dashboard?view=platform-control';

  return (
    <DashboardLayout
      title="606 MediaDocs (التحكم)"
      titleEn="606 MediaDocs (Control)"
      subtitle=""
      subtitleEn=""
      screenCode="MED-000"
      backPath={backTarget}
      onBack={() => navigate(backTarget)}
      breadcrumb={[
        { labelAr: 'التحكم والمعلومات', labelEn: 'Control & Info', path: backTarget },
        { labelAr: '606 MediaDocs (التحكم)', labelEn: '606 MediaDocs (Control)' },
      ]}
    >
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center py-20"
          data-testid="mediadocs-control-coming-soon"
        >
          <div className="w-24 h-24 mx-auto mb-6 rounded-2xl bg-white/[0.02] border border-white/10 flex items-center justify-center">
            <Construction className="w-12 h-12 text-[#EC4899]/60" />
          </div>
          <h3 className="text-2xl font-bold text-[#F5F5F5] mb-2">
            {isAr ? 'قريباً' : 'Coming Soon'}
          </h3>
          <p className="text-[#71717A] text-sm">
            {isAr ? 'التحكم بالمكتبة الرقمية' : 'Digital Library Control'}
          </p>
        </motion.div>
      </section>
    </DashboardLayout>
  );
}
